<template>
  <div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card width="500px">
        <v-card-text>
          <v-text-field label="Name" v-model="name" :rules="nameRules" required ></v-text-field>
          <v-text-field label="IP" v-model="ip" :rules="ipRules" required></v-text-field>
          <v-text-field label="Port" v-model="port" :rules="portRules" required></v-text-field>
          <v-text-field label="MAC Address" v-model="mack" :rules="mackRules" required></v-text-field>
          <v-layout row >
                <v-flex  >
                  <v-file-input @change="handleImage" accept="image/*" prepend-icon="camera_alt" ></v-file-input>
                </v-flex>
                <v-flex  xs1>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon  color="primary" dark v-bind="attrs" v-on="on"><v-icon>info</v-icon></v-btn>
                  </template>
                  <span>Please upload a 600 x 200 png with transparent background for the best experience!</span>
                </v-tooltip>
                </v-flex>
          </v-layout>
          
          
          <v-text-field label="User" v-model="user" :rules="userRules" required></v-text-field>
          <v-text-field label="Password"  v-model="password" type="password"></v-text-field>
          <v-select :items="systems" v-model="os_type"  label="OS" :rules="osRules" required ></v-select>
          <v-btn v-on:click="save" color="secondary" >Save</v-btn>
          <span style="display: inline-block; width: 20px"></span>
          <v-btn v-on:click="cancel" color="lightgray" >Cancel</v-btn>
          <v-snackbar v-model="snackbar" :timeout="1600" > {{ text }}</v-snackbar>
      
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import ComputresApi from "../services/Computers.js";

export default {
  name: "Computer",
  data() {
    return {
      computers_id: 0,
      ip: "",
      port: "7",
      mack: "",
      name: "",
      image: "",
      sImage: "",
      user: "",
      password: "",
      os_type: "",
      snackbar: false,
      text: "",
      systems: [ "Windows", "Linux" ],
      valid: true,
      nameRules: [v => !!v || "Name is required"],
      ipRules: [v => !!v || "IP is required"],
      portRules: [v => !!v || "Port is required"],
      mackRules: [v => !!v || "Mack is required"],
      userRules: [v => !!v || "User is required"],
      osRules: [v => !!v || "System is required"],
    };
  },
  methods: {
      handleImage(selectedImage) {
          
        if (selectedImage) 
          this.sImage = selectedImage;
        else this.sImage = undefined;
        //this.createBase64Image(selectedImage);
      },
      uploadImage(id, image) {

        if(image) {
          const formData = new FormData();
          formData.append("file", image);
          ComputresApi.uploadImage(id, formData).then(function () {
            this.text = "Saved successfully!";
            this.snackbar = true;
          }.bind(this));
        }
      },
      createBase64Image(fileObject) {
          const reader = new FileReader();
          reader.onload = (e) => {
              this.image = e.target.result;
          };
          reader.readAsDataURL(fileObject);
      },
      cancel() {
        this.$router.push("/");
      },
      save() {
          if(!this.$refs.form.validate())
            return;
          var data = {
            ip: this.ip,
            port: this.port,
            mack: this.mack,
            name: this.name,
            user: this.user,
            password: this.password,
            os_type: this.os_type
          };
          
          if(this.$route.params.id && !isNaN(this.$route.params.id)) {
            data.computers_id = this.$route.params.id;
            ComputresApi.update(data).then(function (response) {
                this.uploadImage(response.data.computer_id, this.sImage);
                if(!this.sImage) {
                  this.text = "Saved successfully!";
                  this.snackbar = true;
                }
            }.bind(this));
          }
          else {
            data.password = this.password;
            ComputresApi.insert(data).then(function (response) {
                this.uploadImage(response.data.computer_id, this.sImage);
                if(!this.sImage) {
                  this.text = "Saved successfully!";
                  this.snackbar = true;
                }
            }.bind(this));
          }
      }
  },
  created() {
    if(this.$route.params.id == 'add') {
      return;
    }
    else if (!this.$route.params.id || isNaN(this.$route.params.id))
      this.$router.push("/");

    ComputresApi.getById(this.$route.params.id).then(function(response) {
      this.computers_id = response.data.computers_id;
      this.ip = response.data.ip;
      this.port = response.data.port;
      this.mack = response.data.mack;
      this.name = response.data.name;
      this.image = response.data.image;
      this.user = response.data.user;
      this.os_type = response.data.os_type;
    }.bind(this));
  }
};
</script>



<style scoped>
</style>